export function redirectToPaymentGateway(requestResponse) {
  if (requestResponse?.startPayUrl) {
    window.location.href = requestResponse.startPayUrl;
    return;
  }

  if (requestResponse?.gateway === "sep" || requestResponse?.isSep) {
    const token = requestResponse.token || requestResponse.authority;
    window.location.href = `https://www.doclinkapp.ir/start-pay.html?gateway=sep&token=${encodeURIComponent(token)}`;
    return;
  }

  const baseUrl =
    process.env.NODE_ENV === "development"
      ? "https://sandbox.zarinpal.com/pg/StartPay/"
      : "https://www.zarinpal.com/pg/StartPay/";

  window.location.href = `${baseUrl}${requestResponse.authority}`;
}
